<div class="best-fare-options">
  <idp-info-tooltip
    [infoModal]="bookWidgetAem.bestFareOptionsField.infoModal"
    [attr.aria-label]="
      bookWidgetAem.bestFareOptionsField.bestFare +
      ' ' +
      bookWidgetAem.helpIconAriaLabel
    "
    [toolTipPosition]="toolTipPosition"
  ></idp-info-tooltip>
  <mach-select
    [title]="bookWidgetAem.bestFareOptionsField.bestFare"
    [content]="bookWidgetFields.bestFareOptionsField.dropdownOptions"
    [disabled]="bookWidgetFields.bestFareOptionsField.disable"
    (action)="onDropdownSelectionChange($event)"
  ></mach-select>
</div>
